import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-758a5bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-end mb-4" }
const _hoisted_2 = { class: "d-lg-flex mb-3" }
const _hoisted_3 = { class: "me-lg-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "table-responsive mb-4 text-break" }
const _hoisted_6 = { class: "table table-borderless w-max-content" }
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = { class: "rounded-top" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "rounded-top" }
const _hoisted_11 = { class: "align-items-center" }
const _hoisted_12 = { class: "default__width" }
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = { class: "w_150" }
const _hoisted_15 = { class: "w-200" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-break" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-break w-200" }
const _hoisted_22 = { class: "text-break" }
const _hoisted_23 = { class: "default__width" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode()
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "w_150" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "unread-count"
}
const _hoisted_33 = { class: "default__width" }
const _hoisted_34 = ["onClick", "src"]
const _hoisted_35 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_36 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_37 = { class: "d-lg-flex mb-3" }
const _hoisted_38 = { class: "me-lg-4" }
const _hoisted_39 = { class: "d-flex align-items-center" }

import { ref, watchEffect, computed, watch, PropType, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Pagination from '@/components/pagination/index.vue'
import CellSort from '@/components/sort-field-table/index.vue'
import { translate } from '@/languages/i18n'
import { COMMUNITY_USERS_STORE, COMMUNITY_ALUMNUS_STORE, CONVERSATIONS_STORE, COMMUNITY_STORE } from '@/store/constants'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import ModalAddToGroup from '@/views/community-admin/user-management/shared-components/ModalAddToGroup.vue'
import ModalConfirmAddToGroup from '@/views/community-admin/user-management/shared-components/ModalConfirmAddToGroup.vue'
import ModalConfirmDelete from './components/ModalConfirmDelete.vue'
import ModalComplete from './components/ModalComplete.vue'
import ModalInvite from './components/ModalInvite.vue'
import ModalCompleteInvite from './components/ModalCompleteInvite.vue'
import TotalRecords from '@/components/total-records/index.vue'
import communityAlumnusServices from '@/services/community-alumnus.services'
import Loading from '@/components/loading/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import _ from 'lodash'
import { omit } from 'lodash'
import { formatUnreadCount } from '@/constants/common.ts'
import { isSaasTypePool } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  dataQuery: Object,
  isFilter: Boolean,
},
  setup(__props) {

const props = __props

const router = useRouter()
const route = useRoute()
const store = useStore()

const dataUsers = computed(() => store.getters[COMMUNITY_USERS_STORE.GETTERS.GET_LIST_COMMUNITY_USERS]?.listCommunityUsers)
const totalPages = computed(() => store.getters[COMMUNITY_USERS_STORE.GETTERS.GET_LIST_COMMUNITY_USERS]?.total_pages)
const totalRecords = computed(() => store.getters[COMMUNITY_USERS_STORE.GETTERS.GET_LIST_COMMUNITY_USERS]?.total_records)
const listManagementNo = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.LIST_MANAGEMENT_NO].employee)
const allRecords = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_ALL_DATA]?.employee)


const data = ref<any[]>([])
const isCheckedAll = ref(false)
const listUserFailed = ref<any[]>([])
const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const getCommunityUsers = (params: any) => {
  store.dispatch(COMMUNITY_USERS_STORE.ACTIONS.SET_LIST_COMMUNITY_USERS, {
    id: router.currentRoute.value.params?.id,
    params,
    data: props.dataQuery,
  })
}

onMounted(async () => {
  if (allRecords.value?.length > 0 && listManagementNo.value.length == allRecords.value.length) {
    isCheckedAll.value = true
  } else {
    isCheckedAll.value = totalRecords.value > 0 && listManagementNo.value?.length === totalRecords.value
  }
})

watchEffect(() => {
  data.value = dataUsers.value?.map((item: any) => {
    return { ...item, isChecked: false }
  })
})

const modalGroupData = ref<any>({})
const setModalGroupData = (data: { id: string; name: string }) => {
  modalGroupData.value = data
}

const transitMessageCommon = () => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, listManagementNo.value)

  router.push(`/community/communities/${route?.params?.id}/community-users/send_messages?user_type=1`)
  //transit to OE50
}

const transitUserManagementFlag = () => {
  store.dispatch(COMMUNITY_USERS_STORE.ACTIONS.SET_USER_SELECTED, listManagementNo.value)

  router.push(`/community/communities/${router.currentRoute.value.params?.id}/community-users/user-management-flag-update`)
  //transit to OE53
}

const handleCheckID = (id: string) => {
  const dataCheck = data.value.filter((record) => record.management_no === id)
  const payload = {
    typeData: 'employee',
    data: dataCheck[0],
  }
  if (dataCheck.length > 0) store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_LIST_MANAGEMENT_NO, payload)

  if (allRecords.value?.length > 0 && listManagementNo.value.length == allRecords.value.length) {
    isCheckedAll.value = true
  } else {
    isCheckedAll.value = listManagementNo.value?.length === totalRecords.value
  }
}
const loadingCheckAll = ref<boolean>(false)
const handleCheckAll = async (): void => {
  if (isCheckedAll.value) {
    loadingCheckAll.value = true
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_ALL_DATA, {
      id: route.params?.id,
      data: {
        ...props.dataQuery,
        group_id: route.query?.group_id ?? props.dataQuery.group_id,
      },
      typeData: 'employee',
    })
    await getCommunityUsers({ ...route.query, page_of_number: router.currentRoute.value.query?.page_of_number || 30 })
    const payload = {
      typeData: 'employee',
      type: 'checkAll',
      data: allRecords.value,
    }
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
    loadingCheckAll.value = false
  } else {
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'employee', type: 'unCheckAll', data: [] })
  }
}

const getListUserFailed = (list: any[]): void => {
  listUserFailed.value = list
}

const handleTransitDetail = (idUser: string): void => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/community-users/${idUser}/edit`)
}

const transitDirectChat = (chatroom_id: string) => {
  router.push(`/community/communities/${route.params?.id}/admin/direct_chat/${chatroom_id}`)
}
const transitOnlyManagementFlag = (item: any) => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, [item])
  router.push(`/community/communities/${route.params?.id}/community-users/send_messages?user_type=1`)
}

// 2022/09/27 CW-NamPH Fix for UAT#4497: OE12 (Ph2-R20220930)
const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  // 2022/09/27 CW-NamPH Fix for UAT#4497: OE12 (Ph2-R20220930)
])

watch(
  [
    () => route.query?.page,
    () => route.query?.page_of_number,
    () => route.query?.management_no,
    () => route.query?.customer_name,
    () => route.query?.last_login,
    () => route.query?.record_status,
    () => route.query?.department_name,
    () => route.query?.email,
  ],
  () => {
    if (route.path.match('/community-users')) {
      getCommunityUsers({ ...route.query, page_of_number: router.currentRoute.value.query?.page_of_number || 30 })
    }
  }
)

watch(
  () => route.path,
  () => {
    store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'employee', type: 'unCheckAll', data: [] })
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(storeSaasType) && !_unref(isSaasTypePool)(_unref(storeSaasType)))
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              title: _unref(translate)('OE12addToGroup'),
              type: "secondary",
              "class-name": "me-lg-4 mb-4",
              dataBsToggle: "modal",
              dataBsTarget: "#modalAddUserToGroup",
              disabled: _unref(listManagementNo).length === 0
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(Button, {
          title: 'メッセージ一括送信',
          type: 'secondary',
          "class-name": "me-lg-4 mb-4",
          onClick: transitMessageCommon,
          disabled: _unref(listManagementNo).length === 0
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: 'ユーザ管理フラグ一括更新',
          type: 'secondary',
          "class-name": "me-lg-4 mb-4",
          onClick: transitUserManagementFlag,
          disabled: _unref(listManagementNo).length === 0
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: _unref(translate)('deleteList'),
          type: 'secondary',
          "class-name": "me-lg-4 mb-4",
          dataBsToggle: 'modal',
          dataBsTarget: '#modalConfirmDeleteUsers',
          disabled: _unref(listManagementNo).length === 0
        }, null, 8, ["title", "disabled"]),
        _createVNode(Button, {
          title: _unref(translate)('OE12bulkInvite'),
          type: 'secondary',
          "class-name": "mb-4",
          dataBsToggle: 'modal',
          dataBsTarget: '#modalConfirmInviteUsers',
          disabled: _unref(listManagementNo).length === 0
        }, null, 8, ["title", "disabled"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(TotalRecords, {
          totalRecords: _unref(totalRecords),
          totalChecked: _unref(listManagementNo).length,
          isChecked: true
        }, null, 8, ["totalRecords", "totalChecked"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Pagination, {
              totalDataOfPage: _unref(dataUsers)?.length,
              totalPage: _unref(totalPages),
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input cursor-pointer",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCheckedAll).value = $event)),
                      onChange: handleCheckAll,
                      value: "",
                      id: "flexCheckDefault"
                    }, null, 544), [
                      [_vModelCheckbox, isCheckedAll.value]
                    ])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_unref(translate)('OE10selectAll')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('managementNo'),
                    keyName: 'management_no'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('fullName'),
                    keyName: 'customer_name'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('email'),
                    keyName: 'email'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('OE20belongs'),
                    keyName: 'department_name'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('OE12fieldStatus'),
                    keyName: 'record_status'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('lastLoginDate'),
                    keyName: 'last_login'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", {
                  class: "break-word",
                  innerHTML: _unref(translate)('OE10userDirect')
                }, null, 8, _hoisted_9),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(translate)('message')), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["align-middle text-center", {
                rowEven: index % 2 === 0,
                rowExaminated: item.status === 1,
                rowDeleted: item.status === 0,
                rowChecked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no),
              }]),
                  key: index
                }, [
                  _createElementVNode("td", _hoisted_12, [
                    (item.status !== 2)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "form-check-input cursor-pointer",
                          checked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no),
                          onChange: ($event: any) => (handleCheckID(item.management_no)),
                          type: "checkbox",
                          id: "flexCheckDefault"
                        }, null, 40, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.management_no), 1),
                  _createElementVNode("td", _hoisted_15, [
                    (item.status !== 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(UserAliasIcon, {
                            userType: item?.user_type
                          }, null, 8, ["userType"]),
                          _createElementVNode("div", {
                            class: "text-decoration-underline cursor-pointer",
                            onClick: () => handleTransitDetail(item?.management_no)
                          }, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.family_name + ' ' + item.given_name + ' '), 1),
                            (item.status === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(translate)('SO10user30')), 1))
                              : _createCommentVNode("", true),
                            (item.status === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(translate)('OE12pause')), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(item.email || '-'), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(item.department_name || '-'), 1),
                  _createElementVNode("td", _hoisted_23, [
                    (item.status === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(translate)('OE10pause')), 1))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    (item.status === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(translate)('delete')), 1))
                      : _createCommentVNode("", true),
                    (item.status === 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(translate)('OE12notParticipating')), 1))
                      : _createCommentVNode("", true),
                    (item.status === 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(translate)('OE12inUse')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(item.last_login ? _unref(ConvertFromLocalTime)(item.last_login) : '-'), 1),
                  _createElementVNode("td", null, [
                    (item.status === 3)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "wrapper-user",
                          onClick: ($event: any) => (transitDirectChat(item.chatroom_id))
                        }, [
                          _createElementVNode("img", {
                            src: require('@/assets/images/user-active.svg')
                          }, null, 8, _hoisted_31),
                          (item.count_unread)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(formatUnreadCount)(item.count_unread)), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_30))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_33, [
                    (item.status === 3)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "cursor-pointer",
                          onClick: () => transitOnlyManagementFlag(item),
                          src: require('@/assets/images/mail-active.svg')
                        }, null, 8, _hoisted_34))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          (__props.isFilter && !_unref(dataUsers)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(translate)('CC40noData')), 1))
            : _createCommentVNode("", true),
          (!__props.isFilter && !_unref(dataUsers)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(translate)('CC10noData')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(Pagination, {
              totalDataOfPage: _unref(dataUsers)?.length,
              totalPage: _unref(totalPages),
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ])
      ])
    ]),
    _createVNode(ModalAddToGroup, {
      data: _unref(listManagementNo),
      setGroupData: setModalGroupData,
      groupDataId: modalGroupData.value.id,
      showDisplayName: false
    }, null, 8, ["data", "groupDataId"]),
    _createVNode(ModalConfirmAddToGroup, {
      data: _unref(listManagementNo),
      groupData: modalGroupData.value,
      setGroupData: setModalGroupData,
      showDisplayName: false
    }, null, 8, ["data", "groupData"]),
    _createVNode(ModalConfirmDelete, {
      data: _unref(listManagementNo),
      getListUserFailed: getListUserFailed,
      reload: () => getCommunityUsers({ ..._unref(router).currentRoute.value.query, page_of_number: _unref(router).currentRoute.value.query?.page_of_number || 30 })
    }, null, 8, ["data", "reload"]),
    _createVNode(ModalComplete, {
      data: data.value,
      listUserFailed: listUserFailed.value
    }, null, 8, ["data", "listUserFailed"]),
    _createVNode(ModalInvite, {
      data: _unref(listManagementNo),
      getListUserFailed: getListUserFailed,
      reload: () => getCommunityUsers({ ..._unref(router).currentRoute.value.query, page_of_number: _unref(router).currentRoute.value.query?.page_of_number || 30 })
    }, null, 8, ["data", "reload"]),
    _createVNode(ModalCompleteInvite, {
      data: data.value,
      listUserFailed: listUserFailed.value
    }, null, 8, ["data", "listUserFailed"]),
    _createVNode(Loading, { loading: loadingCheckAll.value }, null, 8, ["loading"])
  ], 64))
}
}

})